import React from 'react'
import { Route } from 'react-router-dom'

import Profile from './Profile'

export const ProfileRoutes = ({ path = '' }) => [
  <Route key="profile-main" path={path} element={<Profile />}>
  </Route>
]

export default ProfileRoutes
